import { createBlueprint as e } from "@made-people/blueprint";
const o = e({
  slots: {
    wrapper: "",
    accordionWrapper: "",
    accordion: "",
    content: "",
    text: "",
    link: ""
  },
  variants: {
    layout: {
      vertical: {
        wrapper: "flex flex-col"
      },
      horizontal: {
        wrapper: "flex flex-row"
      },
      "horizontal-reverse": {
        wrapper: "flex flex-row-reverse"
      },
      "vertical-reverse": {
        wrapper: "flex flex-col-reverse"
      }
    }
  }
});
export {
  o as accordionAndTextTemplate1Blueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
